import { OpalApiResponseDocument } from '@opallabs/api'

type PlanCache = OpalApiResponseDocument<'ExperimentalReadPlanBFFV1', 200>
type CategoryHierarchy = OpalApiResponseDocument<
  'ExperimentalReadPlanBFFV1',
  200
>['data']['categories']['hierarchy']

/** Removes a Swimlane from a plan by its ID */
export const deleteSwimlane = (swimlaneId: string) => {
  return (draftResponse: PlanCache) => {
    delete draftResponse.data.categories.by_id[swimlaneId]

    draftResponse.data.categories.hierarchy =
      draftResponse.data.categories.hierarchy.reduce<CategoryHierarchy>(
        removeSwimlaneFromHierarchy(swimlaneId),
        [] as CategoryHierarchy
      )

    return draftResponse
  }
}

/** Recursively rebuild the category hierarchy without the category we'd like to delete */
const removeSwimlaneFromHierarchy =
  (categoryIdToDelete: string) =>
  (acc: CategoryHierarchy, categoryRef: CategoryHierarchy[number]) => {
    /**
     * Need to cast `children` as `CategoryHierarchy` here because our API docs
     * don't properly nest a recursive type on the current version.
     */
    categoryRef.children = (
      categoryRef.children as CategoryHierarchy
    ).reduce<CategoryHierarchy>(
      removeSwimlaneFromHierarchy(categoryIdToDelete),
      []
    )

    if (categoryRef.id !== categoryIdToDelete) {
      acc.push(categoryRef)
    }

    return acc
  }
